import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIAffiliate = (namespace: CreateNS) => {
    namespace('affiliate')(({ func, prop, deps }) => {
        const getData = () => deps.getAffiliateData();
        prop('utm_source', () => getData().utm_source || '', null);
        prop('source', () => getData().source || '', null);
        prop('awc', () => getData().awc || '', null);
        prop('gclid', () => getData().gclid || '', null);
        prop('fbclid', () => getData().fbclid || '', null);
        prop('channel', () => getData().channel || '', null);
        prop('comissionGroup', () => getData().comissionGroup || '', null);
        func('clear', deps.clearAffiliate);
        func('setData', deps.setAffiliateData);
    });
};
